import SiteFooter from './components/Common/SiteFooter';
import NavBar from "./components/Common/NavBar";
import NotFound from "./components/Common/NotFound";
import ProtectedRoute from './components/Common/ProtectedRoute';
import TawkToChat from './components/Common/TawkToChat.js';
import ScrollToTop from './components/Common/ScrollToTop';

import React, { useState, Suspense } from "react";
import { Route, Routes } from 'react-router-dom';

import './App.css';

import '@aws-amplify/ui-react/styles.css';

import { Authenticator } from '@aws-amplify/ui-react';
import config from './aws-exports';
import { Amplify } from 'aws-amplify';

Amplify.configure(config);

// Lazy load components
const HomePage = React.lazy(() => import('./components/home/HomePage'));
const Pain = React.lazy(() => import('./components/home/Pain'));
const HomePagePoshRx = React.lazy(() => import('./components/home/Beauty'));
const CustomLoginPage = React.lazy(() => import('./components/custom-auth/CustomLoginPage'));
const About = React.lazy(() => import('./components/Pages/About'));
const PaymentSuccess = React.lazy(() => import('./components/paymentProcessing/PaymentSuccess'));
const PaymentFailed = React.lazy(() => import('./components/paymentProcessing/PaymentFailed'));
const Storefront = React.lazy(() => import('./components/Pages/Storefront'));
const Cart = React.lazy(() => import('./components/Pages/Cart'));
const SubmitRequest = React.lazy(() => import('./components/Pages/SubmitRequest'));
const PrescriptionRenewalForm = React.lazy(() => import('./components/Pages/PrescriptionRenewalForm'));
const PrescriptionManagement = React.lazy(() => import('./components/Pages/PresecriptionManagment'));
const Contact = React.lazy(() => import('./components/Pages/Contact'));
const PrivacyPolicy = React.lazy(() => import('./components/Pages/PrivacyPolicy'));
const TermsNConditions = React.lazy(() => import('./components/Pages/TermsNConditions'));
const VerificationCompletePage = React.lazy(() => import('./components/Pages/VerificationCompletePage'));
const Dashboard = React.lazy(() => import('./components/Dashboards/patients/Dashboard.js'));
const TreatmentHistory = React.lazy(() => import('./components/Dashboards/patients/TreatmentHistory'));
const ProfilePage = React.lazy(() => import('./components/Dashboards/patients/ProfilePage.js'));
const DoctorMessagesPage = React.lazy(() => import('./components/Dashboards/doctors/DoctorMessagesPage'));
const PatientMessagesPage = React.lazy(() => import('./components/Dashboards/patients/PatientMessagePage.js'));
const MessagesPage = React.lazy(() => import('./components/Dashboards/patients/MessagesPage'));
const DocDashboard = React.lazy(() => import('./components/Dashboards/doctors/DocDashboard.js'));
const Admin = React.lazy(() => import('./components/Dashboards/Admin'));
const ErectileDysfunctionPage = React.lazy(() => import('./components/Pages/ErectileDysfunction'));
const CreatePatientPage = React.lazy(() => import('./components/Pages/CreatePatientPage'));
// New Patient Record components
const PatientRecordPage = React.lazy(() => import('./components/Dashboards/doctors/PatientRecordPage'));

// Loading fallback component
function LoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-teal-500"></div>
    </div>
  );
}

function ComingSoonBanner() {
    const [isVisible, setIsVisible] = useState(true);
  
    return isVisible ? (
      <div className="relative bg-gradient-to-r from-teal-600 to-teal-800">
        <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
          {/* Modified structure to ensure proper centering */}
          <div className="flex justify-center items-center relative">
            {/* Banner text is now absolutely centered */}
            <p className="font-medium text-white text-center w-full">
              <span className="md:hidden">Coming Soon!</span>
              <span className="hidden md:inline">Coming soon! Stay tuned for updates.</span>
            </p>
            
            {/* Close button positioned absolutely to not affect centering */}
            <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
              <button
                type="button"
                className="flex p-2 rounded-md hover:bg-teal-500 focus:outline-none focus:ring-2 focus:ring-white"
                onClick={() => setIsVisible(false)}
              >
                <span className="sr-only">Dismiss</span>
                <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }

function App() {
  return (
    <div className="min-h-screen overflow-x-hidden">
      <Authenticator.Provider>
        <ScrollToTop />
        <ComingSoonBanner />
        <div>
          <NavBar />
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/pain" element={<Pain />} />
                <Route path="/beauty" element={<HomePagePoshRx />} />
                <Route path="/login" element={<CustomLoginPage />} />
                <Route path="/about" element={<About />} />
                <Route path="*" element={<NotFound />} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/payment-cancelled" element={<PaymentFailed />} />
                <Route path="/storefront" element={<Storefront />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/submitRequest" element={<SubmitRequest />} />
                <Route path="/prescription-renewal" element={<PrescriptionRenewalForm />} />
                <Route path="/prescription-managment" element={<PrescriptionManagement />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsNConditions />} />
                <Route path="/erectile-dysfunction" element={<ErectileDysfunctionPage />} />
                <Route path="/verification-complete" element={
                    <VerificationCompletePage />
                } />
                <Route path="/create-patient" element={
                        <ProtectedRoute>
                            <CreatePatientPage />
                        </ProtectedRoute>
                    } />
                <Route path="/dashboard" element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    } />
                <Route path="/history" element={
                        <ProtectedRoute>
                            <TreatmentHistory />
                        </ProtectedRoute>
                    } />
                <Route path="/profile" element={
                        <ProtectedRoute>
                            <ProfilePage />
                        </ProtectedRoute>
                    } />
                    <Route 
                        path="/doctor/messages" 
                        element={
                          <ProtectedRoute>
                            <DoctorMessagesPage />
                          </ProtectedRoute>
                        } 
                      />
                <Route path="/messages" element={
                      <ProtectedRoute>
                        <PatientMessagesPage />
                      </ProtectedRoute>
                    } />
                    <Route path="/messages/:conversationId" element={
                      <ProtectedRoute>
                        <MessagesPage />
                      </ProtectedRoute>
                    } />
                <Route path="/docdashboard" element={
                        <ProtectedRoute>
                            <DocDashboard />
                        </ProtectedRoute>
                    } />
                <Route path="/admin" element={
                        <ProtectedRoute>
                            <Admin />
                        </ProtectedRoute>
                    } />
                <Route path="/records/patient/:patientId" element={
                        <ProtectedRoute>
                            <PatientRecordPage />
                        </ProtectedRoute>
                    } />
                </Routes>
          </Suspense>
          <SiteFooter />
          <TawkToChat />
        </div>
      </Authenticator.Provider>
    </div>
  );
}

export default App;